module.exports = __webpack_public_path__ + "static/media/Logo.f2320804.PNG";